import cn from 'classnames';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { User } from '@/shared/api/protocol-ts/model/dto_user_pb';
import { useAppSelector, useMedia } from '@/shared/hooks';
import { getName } from '@/shared/lib';
import { Button, Input } from '@/shared/ui';

import { userModel } from '@/entities/user';

import styles from './AddSignature.module.scss';

type ReportSignsProps = {
  user: User;
  loading: boolean;
  handleSign: () => void;
  className?: string;
};

export const AddSignature: FC<ReportSignsProps> = (props) => {
  const { user, loading, handleSign, className } = props;
  const userLocale = useAppSelector(userModel.selectors.selectUserLocale);

  const userName = getName(
    user?.PersonalData?.FirstName,
    user?.PersonalData?.LastName,
    {
      userLocale,
    },
  );

  const { isPhone, isMobile } = useMedia();

  const buttonSize = isMobile ? 'medium' : 'large';

  return (
    <div
      className={cn(styles.container, className)}
      data-component="add-report-signature"
    >
      <h5 className={cn(styles.signedTitle, 'h5')}>
        <FormattedMessage
          id="report.addSignature"
          defaultMessage="Add signature"
        />
      </h5>

      <div className={styles.addSignature}>
        <Input name="signature" value={userName} />
        <Button
          variant="secondary"
          loading={loading}
          onClick={handleSign}
          size={buttonSize}
        >
          {isPhone ? (
            <FormattedMessage id="report.sign" defaultMessage="Sign" />
          ) : (
            <FormattedMessage
              id="report.signReport"
              defaultMessage="Sign the report"
            />
          )}
        </Button>
      </div>
    </div>
  );
};
